import React from 'react';
import { EligibleTrainingDetailPage } from '@/components/training/EligibleTrainingDetailPage';
import { eligibleTrainingsData } from '@/data/eligibleTrainings';
import { useLanguage } from '@/contexts/LanguageContext';

export const LegalDesignAITrainingPage = () => {
  const { language } = useLanguage();
  const data = language === 'fr' ? eligibleTrainingsData.fr['legal-design-ia'] : eligibleTrainingsData.en['legal-design-ai'];
  return <EligibleTrainingDetailPage training={data} />;
};

export const ContractualAITrainingPage = () => {
  const { language } = useLanguage();
  const data = language === 'fr' ? eligibleTrainingsData.fr['ia-taches-contractuelles'] : eligibleTrainingsData.en['ai-contractual-tasks'];
  return <EligibleTrainingDetailPage training={data} />;
};

export const LitigationAITrainingPage = () => {
  const { language } = useLanguage();
  const data = language === 'fr' ? eligibleTrainingsData.fr['ia-contentieux'] : eligibleTrainingsData.en['ai-litigation'];
  return <EligibleTrainingDetailPage training={data} />;
};

export const LegalResearchAITrainingPage = () => {
  const { language } = useLanguage();
  const data = language === 'fr' ? eligibleTrainingsData.fr['ia-recherche-juridique'] : eligibleTrainingsData.en['ai-legal-research'];
  return <EligibleTrainingDetailPage training={data} />;
};

export const LawyerWebsiteAITrainingPage = () => {
  const { language } = useLanguage();
  const data = language === 'fr' ? eligibleTrainingsData.fr['ia-site-web-avocat'] : eligibleTrainingsData.en['ai-lawyer-website'];
  return <EligibleTrainingDetailPage training={data} />;
};

export const AISecurityTrainingPage = () => {
  const { language } = useLanguage();
  const data = language === 'fr' ? eligibleTrainingsData.fr['ia-securite-secret-professionnel'] : eligibleTrainingsData.en['ai-security-professional-secrecy'];
  return <EligibleTrainingDetailPage training={data} />;
};
